import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			btnSelect: {
				padding: "8px 15px",
				borderRadius: "17px 0px 6px !important",
				textAlign: "center",
				boxShadow: "none",
				background: theme.palette.grey[600],
				color: theme.palette.primary.contrastText,
				"&:active": {
					cursor: "pointer",
					opacity: 0.7
				},
				"&:hover": {
					boxShadow: "none",
					background: theme.palette.grey[600],
					opacity: 0.7
				}
			},
			btnUnSelect: {
				padding: "8px 15px",
				borderRadius: "17px 0px 6px !important",
				textAlign: "center",
				boxShadow: "none",
				background: theme.palette.button.main,
				color: theme.palette.common.white,
				"&:active": {
					cursor: "pointer",
					opacity: 0.7
				},
				"&:hover": {
					boxShadow: "none",
					background: theme.palette.button.main
				}
			}
		}),
	{
		name: "Cart",
		index: 1
	}
);

export default useStyles;
